export function scroll() {
  document.addEventListener("DOMContentLoaded", () => {
    // p-main-job__imagesWrapに対するスクロール設定
    const jobsImagesContainer = document.querySelector(".p-main-job__imagesWrap");
    const secondJobElement = document.querySelectorAll(".p-main-job__image")[1]; // 2番目の要素を選択

    if (secondJobElement) {
      const jobElementOffset = secondJobElement.offsetLeft;
      const jobAdjustment = jobElementOffset * 0.35; // 調整
      jobsImagesContainer.scrollLeft = jobElementOffset - jobAdjustment;
    }

    // p-main-person__listsWrapに対するスクロール設定
    const personsListsContainer = document.querySelector(".p-main-person__listsWrap");
    const secondPersonElement = document.querySelectorAll(".p-main-person__list")[1]; // 2番目の要素を選択

    if (secondPersonElement) {
      const personElementOffset = secondPersonElement.offsetLeft;
      const personAdjustment = personElementOffset * 0.4; // 調整
      personsListsContainer.scrollLeft = personElementOffset - personAdjustment;
    }
  });

  // . js-figure-imagesにスクロールされたら、子要素の.js-figure-imageに0.2秒ずつ遅れてis-showクラスを付与
  const figureImages = document.querySelectorAll(".js-figure-images");
  figureImages.forEach((figureImage) => {
    const figureImageChildren = figureImage.querySelectorAll(".js-figure-image");
    const figureImageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            figureImageChildren.forEach((child, index) => {
              setTimeout(() => {
                child.classList.add("is-show");
              }, index * 300);
            });
          }
        });
      },
      {
        rootMargin: "-20% 0px",
      }
    );
    figureImageObserver.observe(figureImage);
  });

  // スクロール汎用関数
  // 画面の高さ20%に入ったらis-showクラスを付与
  const scrollObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-show");
        }
      });
    },
    {
      rootMargin: "-20% 0px",
    }
  );

  const scrollElements = document.querySelectorAll(".js-scroll");
  scrollElements.forEach((scrollElement) => {
    scrollObserver.observe(scrollElement);
  });
  

}
